module.exports = {"audiences":["allMembers"],"experimentAllocation":1,"defaultWeight":1,"defaults":{"showNewBillingComponent":false},"variations":[{"name":"billing","weight":1,"values":{"showNewBillingComponent":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/billingComponent.json
// module id = 7Cjx
// module chunks = 2